import uuid from 'react-native-uuid';

export default function getKeyFromEmpIdOrUUID(employeeId: string | null | undefined): string {
  if (employeeId && employeeId !== null) {
    return employeeId;
  }
  return uuid.v4();
}
